<script lang="ts">
	import { Separator } from '$lib/components/ui/separator';
	import {
		formatPriceBreakdownLine,
		type PriceBreakdownLine
	} from '$lib/listing-pricing/calculate';

	let {
		lines,
		total,
		currency = 'EUR',
		compact = false,
		discount = null
	}: {
		lines: PriceBreakdownLine[];
		total: number;
		currency?: string;
		compact?: boolean;
		/** Discount already subtracted from `total` (voucher). */
		discount?: { label: string; amount: number } | null;
	} = $props();

	const currencySymbol = $derived(currency === 'EUR' ? '€' : currency);
	const hasDiscount = $derived(!!discount && discount.amount > 0);
</script>

<div class={compact ? 'space-y-2 text-sm' : 'space-y-2 text-base/7 sm:text-sm/6'}>
	<dl class="space-y-2">
		{#each lines as line (line.listingDateRangeId + line.startDate + line.unitPrice)}
			<div class="flex justify-between gap-3">
				<dt class="text-slate-600">{formatPriceBreakdownLine(line)}</dt>
				<dd class="shrink-0 font-medium">{line.subtotal.toFixed(2)}{currencySymbol}</dd>
			</div>
		{/each}
		{#if hasDiscount && discount}
			<div class="flex justify-between gap-3 text-green-700">
				<dt>{discount.label}</dt>
				<dd class="shrink-0 font-medium">−{discount.amount.toFixed(2)}{currencySymbol}</dd>
			</div>
		{/if}
	</dl>

	<Separator />

	<div class="flex justify-between pt-1 {compact ? 'text-sm' : 'text-base'}">
		<span class="font-medium">Total</span>
		<span class="text-kbprimary font-bold">{total.toFixed(2)}{currencySymbol}</span>
	</div>
</div>
